import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import TagManager from 'react-gtm-module';

//STYLES
import './assets/styles/style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

//NAVS

//PAGES
import AppRouter from './routes/AppRouter';
import AppRouterMaintenance from './routes/AppRouterMaintenance';

const tagManagerArgs = {
  gtmId: 'GTM-W44FC5T' // Reemplaza con tu ID de contenedor de Google Tag Manager
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  process.env.REACT_APP_MAINTENANCE === "true" ? <AppRouterMaintenance /> : <AppRouter />
);




serviceWorkerRegistration.register();